import React from 'react';
import { motion } from 'framer-motion';
export function AuthorStory() {
  return <section className="py-10 px-4 bg-white" data-id="element-32">
      <div className="max-w-[640px] mx-auto text-center" data-id="element-33">
        {/* Línea divisoria decorativa */}
        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-34">
          <div className="w-12 h-px bg-terracotta/40" data-id="element-35"></div>
          <div className="w-2 h-2 rounded-full bg-terracotta/60" data-id="element-36"></div>
          <div className="w-12 h-px bg-terracotta/40" data-id="element-37"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-38">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-navy" data-id="element-39">
            Por qué existe este libro
          </h2>

          <div className="space-y-4 text-base md:text-lg text-navy/80 leading-relaxed text-left" data-id="element-40">
            <p data-id="element-41">
              Hace algunos años mi madre fue diagnosticada con cáncer de colon.
              Todo ocurrió muy rápido.
            </p>

            <p data-id="element-42">
              En menos de un mes pasamos del diagnóstico a despedirnos de ella.
            </p>

            <p data-id="element-43">
              Ese tiempo me permitió ver algo que muchas personas viven durante
              años:{' '}
              <span className="font-semibold text-navy" data-id="element-44">
                el peso emocional de cuidar a un padre o una madre cuando la
                vida empieza a volverse frágil.
              </span>
            </p>

            <p data-id="element-45">
              Con el paso del tiempo comprendí que miles de hijos —y sobre todo
              hijas— atraviesan ese camino en silencio.
            </p>

            <p data-id="element-46">Muchas sienten:</p>

            <ul className="space-y-2 pl-4" data-id="element-47">
              <li className="flex items-start gap-2" data-id="element-48">
                <span className="w-1.5 h-1.5 bg-terracotta rounded-full mt-2.5 shrink-0" data-id="element-49"></span>
                <span data-id="element-50">Agotamiento</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-51">
                <span className="w-1.5 h-1.5 bg-terracotta rounded-full mt-2.5 shrink-0" data-id="element-52"></span>
                <span data-id="element-53">Culpa por querer un momento para sí mismas</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-54">
                <span className="w-1.5 h-1.5 bg-terracotta rounded-full mt-2.5 shrink-0" data-id="element-55"></span>
                <span data-id="element-56">
                  La sensación de que su vida quedó en pausa mientras cuidan a
                  alguien que aman
                </span>
              </li>
            </ul>

            <p className="font-medium text-navy" data-id="element-57">
              Este libro nació con una intención muy simple:
            </p>

            <p className="text-xl font-serif italic text-terracotta text-center" data-id="element-58">
              acompañar a quienes están viviendo ese momento y recordarles que
              no están solos.
            </p>

            <p data-id="element-59">
              Por eso reuní aquí las herramientas que me hubiera gustado tener
              cuando ese peso empezó a caer sobre mis hombros.
            </p>
          </div>

          <div className="pt-4" data-id="element-60">
            <p className="text-sm text-navy/50 italic" data-id="element-61">
              — Autor de{' '}
              <span className="font-medium" data-id="element-62">Cuando Todo Recae Sobre Ti</span>
            </p>
          </div>

          <div className="border-t border-navy/10 pt-6" data-id="element-63">
            <p className="text-lg md:text-xl font-serif font-bold italic text-navy" data-id="element-64">
              Este libro no es teoría. Es un mapa para los momentos en que todo
              empieza a recaer sobre ti.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}